import API from 'utils/API'
import { message } from 'antd'
import {
  ULTRA_VOUCHER_REQUEST,
  ULTRA_VOUCHER_SUCCESS,
  ULTRA_VOUCHER_FAILURE,
  /* ULTRA_VOUCHER_UPDATED,
  ULTRA_VOUCHER_DETAIL_SUCCESS, */
} from 'constants/ActionTypes'
import history from 'utils/history'

export const ultraVoucherRequest = () => ({
  type: ULTRA_VOUCHER_REQUEST,
})

export const ultraVoucherSuccess = (data, meta) => ({
  type: ULTRA_VOUCHER_SUCCESS,
  data,
  meta,
})

export const ultraVoucherFailure = errorMessage => ({
  type: ULTRA_VOUCHER_FAILURE,
  errorMessage,
})

export const fetchUltraVoucher = params => (
  (dispatch) => {
    dispatch(ultraVoucherRequest())
    const url = `${process.env.APP_CONFIG.api_url_content}/ultra-voucher/product${params || ''}`
    return API.get(url).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          dispatch(ultraVoucherSuccess(data, meta))
        } else {
          dispatch(ultraVoucherFailure(meta.message))
        }
      },
    ).catch((err) => {
      dispatch(ultraVoucherFailure(err.message)) // eslint-disable-line no-console
    })
  }
)

export const updateUltraVoucherProduct = (payload, id) => (
  () => new Promise((resolve, reject) => (
    API.put(`${process.env.APP_CONFIG.api_url_content}/ultra-voucher/set-image/${id}`, payload).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          resolve(data)
          history.push('/ultra-vouchers/products')
        } else {
          reject(meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const fetchSyncData = params => (
  (dispatch) => {
    dispatch(ultraVoucherRequest())
    const url = `${process.env.APP_CONFIG.api_url_content}/ultra-voucher/sync/product${params || ''}`
    return API.get(url).then(
      (response) => {
        const { meta } = response.data
        if (meta.status) {
          message.success(meta.message)
          dispatch(fetchUltraVoucher())
        } else {
          dispatch(ultraVoucherFailure(meta.message))
        }
      },
    ).catch((err) => {
      dispatch(ultraVoucherFailure(err.message)) // eslint-disable-line no-console
    })
  }
)
